import { useCallback, useEffect, useState, useRef } from "react";
import { Box, Portal, Stack, Typography } from "@mui/material";

import { useMenuStore, TimerState } from "../../store/menuState";
import { useInfoStore } from "../../store/userInfo";
// import Logo from "../../components/Logo";
import Category from "./Category";
import ItemDetail from "./ItemDetail";
import ItemList from "./ItemList";
import MenuTab from "./Tabs";
import useIdleTimeout from "../../context/IdleTimeout";
import { useWindowDimensions } from "../../App";
import BottomMenu from "../../components/BottomMenu";
import DrawerCart from "./Cart/DrawerCart";
import { useLongPress } from "use-long-press";
import { useNavigate } from "react-router-dom";
import OrderbookModal from "../../components/Orderbook";
import OrderList, { OrderListMode } from "./OrderList";
import { useOrderStore } from "../../store/order";
import { isBrowser, isTablet } from 'react-device-detect';
import ServerCall from "./ServerCall";
import LanguageMenu from "./Language";
import CompleteModal from "./Cart/CompleteModal";
import CollectInfo from "./OrderList/CollectCall";
import SnackDialog from "../../components/SnackDialog";
import authHeader from "../../api/auth-header";
import { EventSourcePolyfill } from 'event-source-polyfill';
import ConfirmPopup from "../../components/ConfirmPopup";
import HorizontalCarousel from "../promotion";
import { coreInit, initOptions, loadNamespace } from "../../locales/i18n";
import './TouchArea.css';
import DiningTimeEndedDialog from "../../components/DiningTimeEnd";
import { useAppKey } from '../../context/AppKeyContext';
import { sseLogger, logSSEDebugInfo, categorizeSSEError } from '../../utils/sseUtils';
import { sseLog, devLog, menuLog, logger } from '../../utils/logger';
import { useMenuVisibilityTick } from '../../hooks/useMenuVisibilityTick';
// 플랫폼 확인 Android
const isAndroid = /Android/i.test(navigator.userAgent);

const HomePage = () => {
  // const Version = process.env.REACT_APP_VERSION;
  const { userInfo, tableInfo, orderBook, loginMode } = useInfoStore();
  const {
    openOrderList, openServerCall, openLanguageMenu, openComplete, setOrderList,
    openCollect, snackMode, showSnackbar, setShowSnackbar, resetOrderCart, limitValue, totalGuest, openCart, selectedAyce
  } = useOrderStore();
  const { height, width, orientation } = useWindowDimensions();
  const navigate = useNavigate();
  const storeId = userInfo?.storeId;
  // const { t, i18n } = useTranslation([`${storeId}`]);
  const isAyce = userInfo?.isAyce;
  const isKiosk = tableInfo.isKioskMode;
  const { 
    totalOrderTimeLimit, 
    stopTimer,
    isNativeFlag,
    isIdle,
    selectedItem,
    idleState,
    setIsIdle,
    resetMenu,
    resetTimer,
    setCurrentPage,
    isTimerRunning,
    setAskServerClicked,
    askServerClicked,
    timerState
  } = useMenuStore();
  
  // 타이머 시간은 별도로 가져오기 (리렌더링 방지)
  const remaining = useMenuStore((state) => state.remainingOrderTime);
  const [openOrderbook, setOpenOrderbook] = useState(false);
  const [showOrderList, setShowOrderList] = useState(false);
  const { idleTimer } = useIdleTimeout({ idleTime: 60, disableIdleTimer: false });
  const landMode = (orientation === "landscape") ?true: false
  const scaleFactor = width / 1280;
  const promotionSentRef = useRef(false);
  const resetStatusCalledRef = useRef(false);
  // alert(JSON.stringify(width+":"+height))
  let es: EventSourcePolyfill;
  // console.log(width)
  const [askForCheck, setAskForCheck] = useState(false);
  const { refreshApp } = useAppKey();
  
  // 일반 모드에서만 타이머 사용 (AYCE 모드에서는 AyceMenu 페이지에서만 체크)
  // useMenuVisibilityTick(); // SSE MENU_HOUR_SCHEDULE로 대체
  
  // 디버깅: remaining time 변화 추적
  useEffect(() => {
    logger.log('🕐 [Main] remainingOrderTime changed to:', remaining, 'seconds');
    logger.log('🕐 [Main] Calculated time display:', {
      hours: Math.floor(remaining/3600),
      minutes: Math.floor((remaining%3600)/60),
      seconds: remaining%60,
      totalMinutes: Math.floor(remaining/60)
    });
    logger.log('🕐 [Main] totalOrderTimeLimit:', totalOrderTimeLimit);
    logger.log('🕐 [Main] Expected display format:', `${String(Math.floor(remaining/3600)).padStart(2, '0')}:${String(Math.floor((remaining%3600)/60)).padStart(2, '0')}`);
  }, [remaining, totalOrderTimeLimit]);
  
  // 디버깅: 리렌더링 원인 파악
  const prevRenderRef = useRef({ isAyce, selectedAyce, remaining, totalGuest, isTimerRunning });
  
  useEffect(() => {
    const current = { isAyce, selectedAyce, remaining, totalGuest, isTimerRunning };
    const prev = prevRenderRef.current;
    
    const changed: string[] = [];
    if (current.isAyce !== prev.isAyce) changed.push('isAyce');
    if (current.selectedAyce !== prev.selectedAyce) changed.push('selectedAyce');
    if (current.remaining !== prev.remaining) changed.push('remaining');
    if (current.totalGuest !== prev.totalGuest) changed.push('totalGuest');
    if (current.isTimerRunning !== prev.isTimerRunning) changed.push('isTimerRunning');
    

    
    prevRenderRef.current = current;
  });
  
  useEffect(() => {
    connectEventSource();
    setCurrentPage('main')
    return () => {
      if(es) es.close();
    }
  }, [storeId]);

  useEffect(() => {
    if(totalGuest === 0) {
      stopTimer()
      setAskServerClicked(false); // AYCE 메뉴로 돌아갈 때 askServerClicked 초기화
      navigate('/aycemenu')
    }
  },[totalGuest])

  useEffect(() => {
    if(!totalOrderTimeLimit.useAyceTimeLimit) return
    if (totalOrderTimeLimit.ayceTimeLimitMins > 0 && (remaining <= 0 || isTimerRunning === false)) {
      stopTimer();
      setShowOrderList(true);
    }
  }, [totalOrderTimeLimit, remaining, stopTimer]);

  const connectEventSource = () => {
    const eventSourceInitDict = {
      headers: {
        ...authHeader()
      },
      heartbeatTimeout: 100000
    };
    
    const sseUrl = `${process.env.REACT_APP_URI}sse/users?storeId=${storeId}&tableId=${tableInfo.id}`;
    sseLog('🔗 Connecting to SSE:', sseUrl);
    // sseLog('🔑 Auth headers:', eventSourceInitDict.headers);
    
    // Enhanced debugging
    logSSEDebugInfo(sseUrl, eventSourceInitDict.headers, storeId, tableInfo.id);
    
    es = new EventSourcePolyfill(sseUrl, eventSourceInitDict);

    es.onopen = () => {
      sseLog("✅ SSE Connection opened successfully!");
      sseLog("📊 Connection details:", {
        url: sseUrl,
        storeId,
        tableId: tableInfo.id,
        readyState: es.readyState
      });
    };
    
    es.onerror = (e) => {
      const errorType = categorizeSSEError(es.readyState, e);
      sseLogger.logError(errorType, 'SSE connection error', e, sseUrl, es.readyState);
      
      logger.error("❌ SSE Connection error:", {
        error: e,
        readyState: es.readyState,
        url: sseUrl,
        timestamp: new Date().toISOString(),
        errorType
      });
      
      // Enhanced error categorization
      if (es.readyState === EventSource.CONNECTING) {
        logger.error("🔄 Connection failed - attempting to reconnect...");
      } else if (es.readyState === EventSource.CLOSED) {
        logger.error("🚫 Connection closed - check server status and authentication");
      }
    };
    
    es.onmessage = (e) => {
      logger.log("📨 SSE Message received:", e.data);
      try {
        const esData = JSON.parse(e.data);
        logger.log("📋 Parsed SSE data:", esData);
        
        switch (esData.type) {
          case 'REFRESH_SCREEN':
            logger.log("🔄 Refreshing screen...");
            refreshApp();
            break;
          case 'RELOAD_APP':
            if(!isBrowser){
              if (window.Android !== undefined) {
                window.Android.postMessage(JSON.stringify({ type: 'reload' }));
              } else if(window.ReactNativeWebView !== undefined) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'reload' }));
              }
            }
            break;
          case 'LANGUAGE':
            logger.log("🌐 Language change detected");
            loadNamespace(`${userInfo?.storeId}`);
            coreInit(initOptions);
            break;
          case 'TABLE_STATUS':
            logger.log("🪑 Table status update:", esData.payload);
            if(esData.payload.tableStatusId <= 2 && isAyce) {
              logger.log('🔄 Resetting AYCE menu due to table status change');
              resetTimer()
              resetMenu()
              resetOrderCart()
              stopTimer()
              setAskServerClicked(false); // AYCE 메뉴로 돌아갈 때 askServerClicked 초기화
              navigate('/aycemenu')
            }
            break;
          case 'AYCE_OCCUPANCY':
            logger.log("👥 AYCE occupancy update:", esData.payload);
            if(isAyce) {
              if(esData.payload?.currentAdults + esData.payload?.currentChildren > 0) {
                resetTimer()
                stopTimer()
                setAskServerClicked(false); // AYCE 메뉴로 돌아갈 때 askServerClicked 초기화
                navigate('/aycemenu')
              }
            }
            break;
          case 'RELAY_POS_TABLE_ORDER':
            logger.log("📋 Order list update:", esData.payload);
            if(esData.payload) {
              setOrderList(esData.payload)
            }
            break;

          default:
            logger.log("❓ Unknown SSE message type:", esData.type);
            return;
        }
      } catch (parseError) {
        sseLogger.logError('parse', 'Failed to parse SSE message', parseError, sseUrl);
        logger.error("❌ Failed to parse SSE message:", {
          error: parseError,
          rawData: e.data,
          timestamp: new Date().toISOString()
        });
      }
    };
  };

  const closeDialog = () => setShowSnackbar(false);

  const callback = useCallback(() => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined){
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    if(!isTablet && !isBrowser) return;
    navigate('/storesetting');
  }, [navigate]);

  const bind = useLongPress(callback, {
    threshold: 2000,
    cancelOnMovement: 25,
    cancelOutsideElement: true,
  });

  const handleOrderBook = () => {
    if (!orderBook) return;
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined){
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    logger.info('orderbook mode');
    setOpenOrderbook(true);
  };

  const resetStatus = () => {
    if (resetStatusCalledRef.current) return;
    resetStatusCalledRef.current = true;
    // if(window.Android !== undefined) {
    //   window.Android.postMessage(JSON.stringify({'type':'play'}));
    // }
    idleTimer.reset();
    setIsIdle(false);
    resetOrderCart();
    setTimeout(() => {
      resetStatusCalledRef.current = false;
      promotionSentRef.current = false;
    }, 1000);
  }

  const diningTimeEndedDialogClose = () => {
    setShowOrderList(false);
    // 프로모션 상태 초기화하여 다시 실행될 수 있도록 함
    promotionSentRef.current = false;
    // setIsIdle(true); // 프로모션 실행을 위한 idle 상태 활성화
    setAskServerClicked(true)
    if(window.Android !== undefined) {
      window.Android?.postMessage(JSON.stringify({ 'type': 'time-limit', data: -1 }));
    }
  }

  const onAskForCheck = () => {
    setShowOrderList(false);
    setAskForCheck(false);
    setAskServerClicked(true)
    // Ask for server 후 IdleTimeout 활성화하여 프로모션 실행
    logger.log('🔄 [Main] Ask for server - IdleTimeout 활성화');
    logger.log('📊 [Main] 현재 상태:', { 
      isIdle, 
      isNativeFlag, 
      promotionSentRef: promotionSentRef.current 
    });

    logger.log('⏰ [Main] 1000ms 후 IdleTimeout 활성화');

    promotionSentRef.current = false;
    logger.log('✅ [Main] setIsIdle(true) 호출됨');
    if(window.Android !== undefined) {
      window.Android?.postMessage(JSON.stringify({ 'type': 'time-limit', data: -1 }));
      logger.log('📱 [Main] Android time-limit 메시지 전송');
    }
 
  }

  useEffect(() => {
    logger.log('🔄 [Main] 프로모션 useEffect 실행 조건 체크:', { 
      isIdle, 
      isNativeFlag, 
      promotionSentRef: promotionSentRef.current 
    });
    
    // 웹뷰와 네이티브 모두 호환: isIdle만 체크
    if (isIdle && !promotionSentRef.current) {
      const { totalCount } = useOrderStore.getState();
      logger.log('✅ [Main] 프로모션 실행 조건 만족, totalCount:', totalCount);
      
      // 카트가 비어있는 경우에만 프로모션 실행
      if (totalCount === 0) {
        logger.log('🚀 [Main] 프로모션 실행!');
        idleTimer.pause();
        
        // 네이티브 환경에서만 Android 메시지 전송
        if (isNativeFlag && window.Android) {
          window.Android.postMessage(JSON.stringify({ type: 'promotions' }));
          logger.log('📱 [Main] Android 프로모션 메시지 전송 완료');
        } else {
          logger.log('🌐 [Main] 웹뷰 환경에서 프로모션 실행');
        }
        
        promotionSentRef.current = true;
      } else {
        logger.log('❌ [Main] 카트에 아이템이 있어서 프로모션 실행 불가, totalCount:', totalCount);
        // 카트에 아이템이 있는 경우 프로모션 상태 초기화
        setIsIdle(false);
        promotionSentRef.current = false;
      }
    } else {
      logger.log('❌ [Main] 프로모션 실행 조건 불만족:', { 
        isIdle, 
        isNativeFlag, 
        promotionSentRef: promotionSentRef.current 
      });
    }
  }, [isIdle]);
  
  // 프로모션 종료 이벤트 처리
  useEffect(() => {
    const handlePromotionEnd = (event: MessageEvent) => {
      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (data.action === "endPromotion") {
          resetStatus();
        }
      } catch (error) {
        menuLog("Error parsing message:", error);
      }
    };

    window.addEventListener("message", handlePromotionEnd);
    return () => window.removeEventListener("message", handlePromotionEnd);
  }, []);

  // startPromotionCategorySelect 액션 처리 및 time-limit 메시지 전송
  useEffect(() => {
    const handlePromotionStart = (event: MessageEvent) => {
      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        
        if (data.action === "startPromotionCategorySelect") {
          logger.log("🔄 [Main] startPromotionCategorySelect 액션 처리");
          
          // time-limit 메시지 전송
          if(totalOrderTimeLimit.useAyceTimeLimit) {
            if(askServerClicked) {
              // Ask for server 버튼이 클릭된 경우 -1 전송
              window.Android?.postMessage(JSON.stringify({ 'type': 'time-limit', data: -1 }));
              logger.log("📱 [Main] Ask for server - time-limit: -1 전송");
            } else if(timerState === TimerState.RUNNING) {
              window.Android?.postMessage(JSON.stringify({ 'type': 'time-limit', data: remaining }));
            } else if(timerState === TimerState.FINISHED){
              logger.log("📱 [Main] Timer finished - time-limit: 0 전송");
              window.Android?.postMessage(JSON.stringify({ 'type': 'time-limit', data: 0 }));
            }
          }
        }
      } catch (error) {
        logger.error("Error parsing startPromotionCategorySelect message:", error);
      }
    };

    window.addEventListener("message", handlePromotionStart);
    return () => window.removeEventListener("message", handlePromotionStart);
  }, [totalOrderTimeLimit.useAyceTimeLimit, askServerClicked, timerState, remaining]);

  const remainMinus = Math.floor((remaining%3600)/60)
  const remainTotalMinutes = Math.floor(remaining / 60);
  
    return (
      <Box>
      { (isIdle && !isNativeFlag) ?
        <HorizontalCarousel /> :
        <Stack sx={{ backgroundColor: '#fff', height: height, flexGrow: 1, width: width, position: 'relative' }}>
          <Box sx={{ flexDirection: 'row', width: '100%', backgroundColor: '#f4f4f4' }}>
            <Box sx={{ display: 'flex',   width: '100%', height: height }}>
              <Box sx={{width: landMode ? '25.4rem': '21.5rem',  }}>
                <Category />
              </Box>
              <Box sx={{ width: `calc(100% - ${landMode ? "25.4rem" : "21.5rem"})`, backgroundColor: '#fff' }}>
                <Box sx={{ backgroundColor: '#f4f4f4' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', height: '6.1rem', position: 'relative' }}>
                    {/* <Notice /> */}
                  </Box>
                  <MenuTab />
                </Box>
                <ItemList />
                <BottomMenu />
              </Box>
            </Box>
            <DrawerCart />
          </Box>
          {/* Order Time Out Box */}
          {isAyce && totalOrderTimeLimit.useAyceTimeLimit && (
            <Box
              sx={{
                position: 'absolute',
                left: '50%',
                top: 0,
                transform: 'translateX(-50%)',
                backgroundColor: '#000',
                padding: '8px 24px',
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                height: '6.1rem',
                zIndex: 10
              }}
            >
                <img 
                  style={{ 
                    width: '2.0rem', 
                    height: '2.0rem', 
                  }}
                  src={process.env.PUBLIC_URL+'/assets/images/aycetimer.svg'}
                  alt="time"
                />
                <Typography sx={{ml: '0.8rem', fontSize: '1.6rem', fontWeight: '500', lineHeight: '2.0rem', color: '#bbb', textWrap: 'nowrap', letterSpacing: '0.08rem'}}>Order Time Out</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: '2rem', height: '2.4rem'}}>
                  <Typography sx={{fontSize: '2.0rem', fontWeight: '600', textAlign: 'center', borderRadius: '.8rem', color: remainTotalMinutes <= 11 ? '#ff1f00' : '#fff'}}>{String(Math.floor(remaining/3600)).padStart(2, '0')} : {String(remainMinus).padStart(2, '0')}</Typography>
                </Box>
            </Box>
          )}
          {/* 테이블 번호 Box */}
          <Box
            sx={{
              position: 'absolute', right: `1.5rem`, top: 0, backgroundColor: '#000', borderRadius: '0px 0px 1.5rem 1.5rem',
              display: 'flex', maxWidth: '29.3rem', height: landMode ? '6.1rem': '4.4rem', padding: '.5rem 1.4rem', flexDirection: 'row', ml: '6rem',
              alignItems: 'center', gap: '1rem', flexShrink: 0, zIndex: 11
            }}
            {...bind()}
            onClick={handleOrderBook}
            data-login-mode={loginMode}
          >
            <Typography sx={{ color: '#fff', fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '700', lineHeight: '2.2rem', letterSpacing: '-.018rem', width: landMode ?'5.5rem': '8.8rem' }}>
              Table No.
            </Typography>
            <Typography sx={{ color: '#fff', fontSize: '2.6rem', fontStyle: 'normal', fontWeight: '700', letterSpacing: '-.026rem', textAlign: 'left' }}>
              {tableInfo.tableName}
            </Typography>
          </Box>
          {showSnackbar &&
            <Portal>
              <SnackDialog mode={snackMode} showSnack={showSnackbar} setShowSnack={setShowSnackbar} closeDialog={closeDialog} value={limitValue}/>
            </Portal>
          }
          {(isAyce && showOrderList) && <DiningTimeEndedDialog open={showOrderList} onClose={diningTimeEndedDialogClose} onAskForCheck={onAskForCheck} />}
          {selectedItem && <ItemDetail /> }
          {openOrderbook && <OrderbookModal setOpenOrderbook={setOpenOrderbook} openOrderbook={openOrderbook} />}
          {askForCheck ? <OrderList isOpen={true} mode={OrderListMode.DINING_TIME_ENDED}/> : 
            <OrderList isOpen={openOrderList} mode={OrderListMode.ORDER_LIST}/>}
          {openServerCall && <ServerCall />}
          {openLanguageMenu && <LanguageMenu />}
          {openComplete && <CompleteModal />}
          {openCollect && <CollectInfo />}
          {idleState && !isKiosk && <ConfirmPopup />}
        </Stack>
      }
      </Box>
    );
};

export default HomePage;
